import { inject, Injectable } from '@angular/core';

import { SemantriaAccount } from 'app/providers/bridge-api/account.service';
import { GroupService } from 'app/providers/semantria-api/group.service';
import {
  DashboardTemplatesService,
  Template,
} from '../../../providers/dashboard-templates.service';
import { EnableClassTelemetry } from '../../../services/otel.service';

@EnableClassTelemetry()
@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  private readonly _dashboardTemplatesService = inject(DashboardTemplatesService);
  private readonly _accountService = inject(SemantriaAccount);
  private readonly _groupService = inject(GroupService);

  async list(): Promise<Template[]> {
    const [account, templates] = await Promise.all([
      this._accountService.sub.latest(),
      this._dashboardTemplatesService.list(this._groupService.getSelectedGroupId()),
    ]);

    const filterTemplateByAccountFeature = (t: Template): boolean => {
      if (!t.accountRequirements?.features?.length) {
        return true;
      }

      return t.accountRequirements.features.every((f) => account.features?.includes(f));
    };

    return templates.filter(filterTemplateByAccountFeature);
  }
}
